import { AfterViewInit, Component, Inject, Input, HostListener
       } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { Placeholder } from 'collage-designer/stage/placeholder/placeholder';
import { Utils } from 'core/utils';
import { ToolboxService } from './toolbox.service';

export enum ToolboxType {
  static = 'static',
  overlay = 'overlay',
}

@Component({
    template: '',
    standalone: false
})
export class ToolboxComponent implements AfterViewInit
{
  @Input() public type: ToolboxType;
  @Input() public displayTitle: boolean = true;
  public placeholder?: Placeholder;
  public componentVisible: boolean = false;

  constructor(
      private mir: MatIconRegistry,
      protected sanitizer: DomSanitizer,
      @Inject(ToolboxService) protected toolboxService: ToolboxService)
  {
    this.loadIcon('close');
    this.placeholder = this.toolboxService.placeholder;
  }

  public ngAfterViewInit(): void
  {
    this.setBodyScrollable();
  }

  @Input()
  public set visible(status: boolean)
  {
    if (status && this.type === ToolboxType.overlay) {
      Utils.setBodyScrollable(false);
    }
    this.componentVisible = status;
  }

  @HostListener('window:resize')
  public onResizeToolbox(): void
  {
    this.setBodyScrollable();
  }

  protected loadIcon(icon: string): void
  {
    this.mir.addSvgIcon(
        icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(Utils.url(
            `./assets/img/icons/${icon}.svg`)));
  }

  public btnOKClick(): void
  {
    this.toolboxService.commitChanges();
    Utils.setBodyScrollable(true);
  }

  public btnCancelClick(): void
  {
    this.toolboxService.discardChanges();
    Utils.setBodyScrollable(true);
  }

  private setBodyScrollable(): void
  {
    if (Utils.isSmallDevice() || Utils.isMediumDevice()) {
      if (this.componentVisible && this.type === ToolboxType.overlay) {
        Utils.setBodyScrollable(false);
      }
    }
  }
}
